"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.268 3.626V.19h-1v3.39l-1.875-1.7-.672.74 3.07 2.785 3.083-2.784-.671-.742-1.935 1.747Zm-6.723 4.87h2.132l.969-1.394H2.465l-.92 1.393Zm7.268 0h5.595l-1.005-1.394H7.77l1.042 1.393Zm6.573 1H8.562a.496.496 0 0 1-.4-.202L6.71 7.353v7.537h6.601l-.028-4.927h1v4.955a.973.973 0 0 1-.972.972h-7.6V7.323L4.348 9.28a.501.501 0 0 1-.41.214H.615a.5.5 0 0 1-.417-.776l1.58-2.392a.501.501 0 0 1 .418-.225h11.463c.16 0 .31.078.405.208l1.727 2.393a.498.498 0 0 1-.405.792ZM2.514 15.89h2.688v-1H2.644V9.91h-1v5.11c0 .48.391.87.87.87Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.208 5.829V.117h-1.125v5.642L7.876 2.85l-.756.834 4.56 4.136 4.578-4.137-.754-.834-3.297 2.979ZM1.749 13.023h3.744l1.763-2.534H3.424L1.75 13.023Zm11.391 0h9.057l-1.83-2.534h-9.121l1.894 2.534Zm10.156 1.125H12.86a.563.563 0 0 1-.45-.226l-2.57-3.434h-.015v12.316h10.298a.16.16 0 0 0 .16-.16v-7.579h1.125v7.58c0 .708-.577 1.284-1.285 1.284H8.701V10.49h-.075L6.25 13.905a.562.562 0 0 1-.462.242H.703a.563.563 0 0 1-.469-.873l2.42-3.66a.56.56 0 0 1 .468-.251h17.533a.56.56 0 0 1 .456.233l2.642 3.659a.564.564 0 0 1-.457.892ZM3.61 23.929h4.11v-1.125l-4.115-.003v-7.815H2.48V22.8a1.13 1.13 0 0 0 1.13 1.13Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.277 7.772V.156h-1.5v7.523L10.5 3.801 9.493 4.91l6.082 5.517 6.104-5.515L20.674 3.8l-4.397 3.972ZM2.332 17.364h4.991l2.351-3.38H4.565l-2.233 3.38Zm15.188 0h12.075l-2.439-3.38H14.994l2.526 3.38Zm13.541 1.5H17.145a.75.75 0 0 1-.6-.301l-3.424-4.578h-.02v16.42h13.73a.214.214 0 0 0 .214-.212V20.087h1.5v10.106c0 .944-.77 1.713-1.713 1.713H11.6V13.985h-.1l-3.17 4.557a.749.749 0 0 1-.616.322H.937A.751.751 0 0 1 .312 17.7l3.225-4.88a.747.747 0 0 1 .625-.335H27.54a.75.75 0 0 1 .608.31l3.522 4.88a.752.752 0 0 1-.609 1.189ZM4.812 31.906h5.481v-1.5L4.806 30.4V19.98h-1.5V30.4c0 .83.675 1.505 1.506 1.505Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.21 12.016V0h-1.874v11.876l-6.828-6.193-1.259 1.388 9.097 8.251 9.132-8.25-1.257-1.39-7.01 6.334ZM2.867 26.326h8.058l3.85-5.533h-8.25l-3.658 5.533Zm23.333 0h18.826l-3.994-5.533h-18.97l4.138 5.533ZM46.858 28.2H25.73a.937.937 0 0 1-.75-.375l-5.26-7.032h-.332v25.333h21.047c.29 0 .525-.236.525-.525V30.259h1.874V45.6a2.402 2.402 0 0 1-2.4 2.399h-22.92V20.793h-.457l-4.874 7.005a.937.937 0 0 1-.77.402H1.125a.938.938 0 0 1-.781-1.454l4.896-7.407a.935.935 0 0 1 .782-.42h35.49c.301 0 .585.143.76.388l5.346 7.408a.937.937 0 0 1-.76 1.485ZM7.006 48h8.322v-1.874H7.006a.21.21 0 0 1-.21-.21V30.097H4.922v15.819c0 1.15.935 2.084 2.084 2.084Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.28 16.021V0h-2.499v15.834l-9.104-8.257L19 9.427 31.13 20.43l12.175-11-1.675-1.855-9.349 8.446ZM3.823 35.101h10.744l5.132-7.377h-11L3.823 35.1Zm31.11 0h25.102l-5.325-7.377H29.417l5.517 7.377Zm27.544 2.5h-28.17a1.25 1.25 0 0 1-1-.502l-7.011-9.375h-.444V61.5h28.062a.7.7 0 0 0 .7-.7V40.345h2.5V60.8a3.202 3.202 0 0 1-3.2 3.199H23.353V27.724h-.61l-6.498 9.34a1.25 1.25 0 0 1-1.025.536H1.5a1.25 1.25 0 0 1-1.043-1.938l6.528-9.876c.23-.351.623-.561 1.042-.561H55.35c.4 0 .779.192 1.014.518l7.127 9.877a1.25 1.25 0 0 1-1.013 1.98ZM9.341 64h11.096v-2.5H9.341a.28.28 0 0 1-.28-.279V40.13H6.562v21.09A2.782 2.782 0 0 0 9.342 64Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconRightTrackReturn = function IconRightTrackReturn(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Right Track Return' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "RightTrackReturn"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconRightTrackReturn.sizes = [16, 24, 32, 48, 64];
IconRightTrackReturn.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconRightTrackReturn;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/RightTrackReturn.js
// module id = 2037
// module chunks = 0